var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitnessGripWeights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 20.5759 4.31039 22.1363 4.91345 23.5922C5.5165 25.0481 6.40042 26.371 7.51472 27.4853C8.62902 28.5996 9.95189 29.4835 11.4078 30.0866C12.8637 30.6896 14.4241 31 16 31C17.5759 31 19.1363 30.6896 20.5922 30.0866C22.0481 29.4835 23.371 28.5996 24.4853 27.4853C25.5996 26.371 26.4835 25.0481 27.0866 23.5922C27.6896 22.1363 28 20.5759 28 19C28 17.4241 27.6896 15.8637 27.0866 14.4078C26.4835 12.9519 25.5996 11.629 24.4853 10.5147C23.371 9.40042 22.0481 8.5165 20.5922 7.91345C19.1363 7.31039 17.5759 7 16 7C14.4241 7 12.8637 7.31039 11.4078 7.91345C9.95189 8.5165 8.62902 9.40042 7.51472 10.5147C6.40042 11.629 5.5165 12.9519 4.91345 14.4078C4.31039 15.8637 4 17.4241 4 19V19Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 26.748C12.7889 26.434 11.6682 25.8411 10.7274 25.0167C9.78648 24.1923 9.0515 23.1592 8.58118 22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.60667V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1H20C20.5304 1 21.0391 1.21071 21.4142 1.58579C21.7893 1.96086 22 2.46957 22 3V8.60667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessGripWeights);
export default __webpack_public_path__ + "static/media/FitnessGripWeights.ee99bbcb9922c519e31ab449a7a50dd4.svg";
export { ForwardRef as ReactComponent };